import { render, staticRenderFns } from "./GameListComponent.vue?vue&type=template&id=704bf204"
import script from "./GameListComponent.vue?vue&type=script&lang=js"
export * from "./GameListComponent.vue?vue&type=script&lang=js"
import style0 from "./GameListComponent.vue?vue&type=style&index=0&id=704bf204&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports